.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.logoLink {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.topBar {
  background: var(--blue-light);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.container {
  background: var(--gray-bg);
  padding: 12px 16px;
  flex: 1;
}

.inner {
  max-width: 640px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pageTitle {
  font-size: 22px;
  font-weight: 600;
  color: var(--text);
  margin: 0;
}

.notAuthorized {
  padding: 32px;
  text-align: center;
  color: var(--gray-text);
  font-size: 15px;
}

.loadError {
  padding: 32px;
  text-align: center;
  color: var(--red);
  font-size: 15px;
}

.loading {
  padding: 32px;
  text-align: center;
  color: var(--gray-text);
  font-size: 15px;
}

.emptyState {
  color: var(--gray-text);
  font-size: 14px;
  padding: 16px 0;
  text-align: center;
}

/* ── Create company form ──────────────────────────────────────────── */

.createForm {
  display: flex;
  gap: 8px;
  align-items: flex-end;
  margin-bottom: 32px;
}

.createFormInput {
  flex: 1;
}

/* ── Company cards ────────────────────────────────────────────────── */

.companyCard {
  background: var(--white);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 20px 24px;
  margin-bottom: 16px;
}

.companyHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.companyName {
  font-size: 16px;
  font-weight: 700;
  color: var(--text);
  margin: 0;
}

.section {
  margin-bottom: 12px;
}

.sectionLabel {
  font-size: 12px;
  font-weight: 600;
  color: var(--gray-text);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.tagList {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: var(--gray-bg);
  border: 1px solid var(--gray-border, #e5e7eb);
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 13px;
  color: var(--text);
}

.tagRemoveButton {
  background: none;
  border: none;
  padding: 0 0 0 4px;
  cursor: pointer;
  color: var(--gray-text);
  font-size: 14px;
  line-height: 1;
  display: flex;
  align-items: center;
}

.tagRemoveButton:hover:not(:disabled) {
  color: var(--red);
}

.tagRemoveButton:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.emptyTag {
  font-size: 13px;
  color: var(--gray-text);
  font-style: italic;
}

.addForm {
  display: flex;
  gap: 6px;
  align-items: flex-end;
}

.addFormInput {
  flex: 1;
}

.fieldError {
  font-size: 12px;
  color: var(--red);
  margin-top: 4px;
}

/* Balance primary button — layout only; colors from Balance CSS vars */
.actionButton {
  white-space: nowrap;
  flex-shrink: 0;
  min-height: 40px;  /* match Balance Input field height so top/bottom edges align */
}

/* Subtle delete/secondary action */
.deleteButton {
  background: none;
  color: var(--gray-text);
  border: 1px solid var(--gray-border);
  white-space: nowrap;
}

.deleteButton:hover:not(:disabled) {
  color: var(--red);
  border-color: var(--red);
}
